import { CaretDownOutlined, CloseCircleOutlined, CrownOutlined, InfoCircleFilled, PlusCircleOutlined } from "@ant-design/icons";
import { Alert, Collapse, Progress, Tabs, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import * as IssuedCardsApi from '../../../api/rank/issuedCardApi';
import { avatarMale, noData, none_rank } from "../../../components/ExportImgFigma";
import RightPopup from "../../../components/Popup/RightPopup";
import { NO_DATA, URL_CUSTOMER, URL_RANK } from "../../../env";
import { capitalizeEachWord, formatPrice } from "../../../until";
import ProgressItem from "./ProgressItem";
import './styles.scss';
import { ICarePolicy } from "../../../api/rank/rankApi";
import { NO_VIEW } from "../../../services/data";
import { formatNumber } from "../../../services/mixin";

const { Text } = Typography;

interface Props {
  className?: string;
  onClose?: () => void;
  dataInfoCardCustomer?: IssuedCardsApi.IInfoCardCustomer
}

const BenefitList: React.FC<{ items: IssuedCardsApi.ListBenefit2[] }> = ({ items }) => {
  const [expandedIds, setExpandedIds] = useState<number[]>([]);

  const toggle = (id: number) => {
    setExpandedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div className="benefit-list">
      {
        items.length > 0
          ?
          items.map(item => {
            const isExpanded = expandedIds.includes(item.id);
            return (
              <div
                key={item.id}
                className={`benefit-list__item${isExpanded ? ' benefit-list__item--expanded' : ''}`}
              >
                <div className="benefit-list__item-header">
                  <div className="benefit-list__item-title">
                    <CrownOutlined className="benefit-list__item-icon" />
                    <span>{item.title}</span>
                  </div>
                  <button
                    className="benefit-list__item-btn"
                    onClick={() => toggle(item.id)}
                  >
                    {isExpanded
                      ? <CloseCircleOutlined className="btn-icon btn-icon--close" />
                      : <PlusCircleOutlined className="btn-icon btn-icon--plus" />
                    }
                  </button>
                </div>
                {isExpanded && item.description && (
                  <div className="benefit-list__item-desc">{item.description}</div>
                )}
              </div>
            );
          })
          :
          <div
            style={{
              textAlign: 'center',
              padding: 20
            }}>
            <br />
            <img src={noData} alt="No data"

              style={{
                maxWidth: 150,
              }} />
            <br />
            <div>Không có dữ liệu</div>
            <br />
          </div>
      }
    </div>
  );
};


const BenefitListV2: React.FC<{ items: ICarePolicy[] }> = ({ items }) => {
  const [expandedIds, setExpandedIds] = useState<number[]>([]);

  const toggle = (id: number) => {
    setExpandedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };

  return (
    <div className="benefit-list">
      {items.length > 0 ? items.map(item => {
        const isExpanded = expandedIds.includes(item.id);
        return (
          <div
            key={item.id}
            className={`benefit-list__item${isExpanded ? ' benefit-list__item--expanded' : ''}`}
          >
            <div className="benefit-list__item-header">
              <div className="benefit-list__item-title "
                style={{
                  width: '80%'
                }}>
                <CrownOutlined className="benefit-list__item-icon" />
                <Tooltip
                  title={
                    <span className="font-regular "

                    >{item.title}</span>
                  }
                >
                  <span className="font-regular text-truncate"
                  >{item.title}</span>
                </Tooltip>

              </div>
              <button
                className="benefit-list__item-btn"
                onClick={() => toggle(item.id)}
              >
                {isExpanded
                  ? <CloseCircleOutlined className="btn-icon btn-icon--close" />
                  : <PlusCircleOutlined className="btn-icon btn-icon--plus" />
                }
              </button>
            </div>
            {
              isExpanded && (
                <div className="">
                  <div className="custome-page-css flex items-center  gap-2">
                    <span>Ngày bắt đầu:</span>
                    <span>{item.dateStart}</span>
                  </div>

                  <div className="custome-page-css flex items-center  gap-2">
                    <span>Ngày kết thúc:</span>
                    <span>{item.dateEnd}</span>
                  </div>

                  <div className="custome-page-css flex items-center  gap-2">
                    <span>Áp dụng thương hiệu xe sở hữu:</span>
                    <span>{item.brands}</span>
                  </div>

                  <div className="custome-page-css flex items-center  gap-2 pb-4">
                    <span className="custome-page-css no-wrap">Áp dụng tên xe sở hữu:</span>
                    <Typography.Paragraph
                      style={{
                        marginBottom: 0
                      }}
                      ellipsis={{
                        rows: 1,
                        tooltip: item.cars
                      }}
                    >
                      {item.cars}
                    </Typography.Paragraph>
                  </div>
                  {/* {items.map(item => */}

                  <CarePolicyCard
                    key={item.id}
                    item={item}
                  />

                  {/* )} */}

                </div>
              )}
          </div>
        );
      })
        :
        <div
          style={{
            textAlign: 'center',
            padding: 20
          }}>
          <br />
          <img src={noData} alt="No data"

            style={{
              maxWidth: 150,
            }} />
          <br />
          <div>Không có dữ liệu</div>
          <br />
        </div>
      }
    </div>
  );
};

interface CarePolicyCardProps {
  item: ICarePolicy;
}

const CarePolicyCard: React.FC<CarePolicyCardProps> = ({ item }) => {

  const [open, setOpen] = useState(true);

  return (

    <div className="care-policy-card care-policy-collapse">

      <Collapse
        className=""
        expandIconPosition="end"
        ghost
        activeKey={open ? ['1'] : []}
        expandIcon={({ isActive }) => (
          <CaretDownOutlined
            rotate={isActive ? 180 : 0}
            style={{
              fontSize: 14,
              color: "#98A2B3",
              transition: "all .2s",
            }}
          />
        )}
        onChange={() => setOpen(!open)}
        items={[
          {
            key: "1",
            label: `Quyền lợi chính sách CSKH đi kèm (${item.benefitPolicies.length})`,
            children:
              item.benefitPolicies.map(x => (
                <div
                  key={x.id}
                  className="pb-1"
                >
                  {x.title}
                </div>
              ))
          }
        ]}
      />

    </div>

  )
}



const ShowDetailBenefit: React.FC<Props> = ({ className, dataInfoCardCustomer, onClose }) => {
  const handleOnClose = () => {
    if (onClose) {
      onClose()
    }
  }

  const infoCustomer = dataInfoCardCustomer?.infoCustomer;
  const listBenefits = dataInfoCardCustomer?.listBenefits ?? [];
  const listCarePolicies = dataInfoCardCustomer?.listCarePolicies ?? [];
  const listBenefitPolicies = dataInfoCardCustomer?.listBenefitPolicies ?? [];
  const nextRankInfo = dataInfoCardCustomer?.nextRankInfo;
  const permissions = dataInfoCardCustomer?.permissions;

  return (
    <RightPopup
      title="Quyền lợi"
      className={className}
      contentClassName="user-card-popup__content"
      onClose={handleOnClose}
    >
      <div className="member-card">
        <div className="member-header">
          <div className="avatar"
            style={{
              height: 80,
              width: 80,
              borderRadius: '100%',
              overflow: 'hidden'
            }}
          >
            <img
              src={URL_CUSTOMER + infoCustomer?.image}
              alt="Avatar"
              onError={(e) => {
                e.currentTarget.src = (avatarMale);
              }}
            />
          </div>

          <div className="member-info">
            <div className="member-name">
              {permissions?.cusName.view ? capitalizeEachWord(infoCustomer?.username ?? '') : NO_VIEW}

            </div>

            <div className="member-rank">
              {permissions?.rank.view ?
                <>
                  <img
                    src={URL_RANK + infoCustomer?.rankIcon}

                    onError={(e) => { e.currentTarget.src = none_rank }}
                    alt=""
                    className="rank-icon"
                  />
                  <span> {infoCustomer?.rankTitle ?? NO_DATA}</span>
                </>
                :
                NO_VIEW
              }
            </div>

            <Text className="member-code">
              Mã thẻ:  {permissions?.cardIssuanceCode.view ? infoCustomer?.codeCard : NO_VIEW}
            </Text>
          </div>
        </div>

        {
          nextRankInfo &&
          <Alert
            icon={<InfoCircleFilled />}
            showIcon
            message={permissions?.points.view ? nextRankInfo?.message : NO_VIEW}
            type="info"
            className="upgrade-alert"
          />
        }
        {/* type ===1 => chi tiêu tích luỹ */}
        {/* Chưa đủ điều kiện */}
        {
          nextRankInfo?.type === 1 && !nextRankInfo.isHighestRank &&

          <ProgressItem
            title="Tổng chi tiêu tích lũy "
            description={permissions?.points.view ? nextRankInfo?.message : NO_VIEW}
            percent={(nextRankInfo?.customerTotalAmount ?? 0) / nextRankInfo?.totalAmount * 100}
          />

        }

        {/* đã đạt rank cao nhất*/}
        {
          nextRankInfo?.type === 1 && nextRankInfo.isHighestRank &&

          <div className="highest-rank-item  pt-4">
            <div className="highest-rank-title">Tổng chi tiêu tích lũy </div>

            <div className="highest-rank-status">
              {nextRankInfo?.message}
            </div>

            <div className="highest-rank-amount">
              {permissions?.points.view ? formatNumber(nextRankInfo?.customerTotalAmount) : NO_VIEW} đ
            </div>
          </div>
        }

        {/* type ===3 => chi tiêu dịch vụ && xe */}
        {/* Đủ điều kiện */}
        {
          nextRankInfo?.type === 2 && !nextRankInfo.isHighestRank &&

          <>
            <ProgressItem
              title="Tổng chi tiêu mua xe "
              description={permissions?.points.view ? nextRankInfo?.purchase.message : NO_VIEW}
              percent={(nextRankInfo?.purchase.customerTotalPurchaseAmount ?? 0) / nextRankInfo?.purchase.totalPurchaseAmount * 100}
            />

            <ProgressItem
              title="Tổng chi tiêu dịch vụ "
              description={permissions?.points.view ? nextRankInfo?.purchase.message : NO_VIEW}
              percent={(nextRankInfo?.service.customerTotalServiceAmount ?? 0) / nextRankInfo?.service.totalServiceAmount * 100}
            />
          </>
        }

        {/* đã đạt rank cao nhất */}
        {
          nextRankInfo?.type === 2 && nextRankInfo.isHighestRank &&

          <>
            <div className="highest-rank-item pt-2">
              <div className="highest-rank-title">Tổng chi tiêu mua xe </div>

              <div className="highest-rank-status">
                {nextRankInfo?.purchase.message}
              </div>

              <div className="highest-rank-amount">
                {permissions?.points.view ? formatNumber(nextRankInfo?.purchase.customerTotalPurchaseAmount) : NO_VIEW} đ
              </div>
            </div>
            <div className="highest-rank-item  pt-4">
              <div className="highest-rank-title">Tổng chi tiêu dịch vụ </div>

              <div className="highest-rank-status">
                {nextRankInfo?.service.message}
              </div>

              <div className="highest-rank-amount">
                {permissions?.points.view ? formatNumber(nextRankInfo?.service.customerTotalServiceAmount) : NO_VIEW} đ
              </div>
            </div>
          </>
        }

      </div>

      <Tabs
        className="detail-rank-tabs"
        items={[
          {
            key: '1',
            label: `Quyền lợi hạng (${formatPrice(listBenefits.length)})`,
            children: <BenefitList items={listBenefits} />,
          },
          {
            key: '2',
            label: `Chính sách CSKH (${formatPrice(listCarePolicies.length)})`,
            children: <BenefitListV2 items={listCarePolicies} />,
          },
          {
            key: '3',
            label: `Quyền lợi chính sách CSKH (${formatPrice(listBenefitPolicies.length)})`,
            children: <BenefitList items={listBenefitPolicies} />,
          },
        ]}
      />
    </RightPopup >
  )
}

export default ShowDetailBenefit
